import GLightbox from 'glightbox';

export let gallery = {

    selector: '.gallery',
    selectorLink : '.gallery__link',

    init : function() {

        if( document.querySelector(this.selector) === null ) return;

        const gallery = GLightbox({
            selector : this.selectorLink,
            touchNavigation: true,
            loop: true,
            autoplayVideos: true,
            openEffect: 'fade',
            closeEffect: 'none',
        });

    }

}